module.exports = __webpack_public_path__ + "img/no-image-sm.364328f.webp";